//-------------------
// save current adjs
//-------------------
export default function saveCurrentAdjs(category, adjs) {
  // --------------------
  // check got adj array
  // --------------------
  if (!Array.isArray(adjs)) return null
  //-----------------------------------
  // create array with specified props
  //-----------------------------------
  const original_adjs = adjs.map((adj) => ({
    category: category ? category : null,
    name: adj.name, // for debug only
    id: adj.id ? adj.id : null,
    adj_value: adj.adj_value ? adj.adj_value : null,
    adj_reason: adj.adj_reason ? adj.adj_reason : null,
    character_item: adj.character_item ? adj.character_item : null,
    source: adj.source ? adj.source : '', // 'characteristic' 'ability' or 'integrated_ rune' (to avoid id lookup issues)
    editable: adj.editable ? adj.editable : false, // used to determine whether to compare original vs current
    rune: adj.rune ? adj.rune : false, // whether adj comes from a rune
    persistable: adj.persistable ? adj.persistable : false,
  }))
  return original_adjs
}
